module.exports = __webpack_public_path__ + "static/media/zip.9b4d35a1.svg";